import { i as isEmpty_1 } from './isEmpty-ea893565.js';
import { a as isBrowser } from './utils-6c8f178b.js';
import { a7 as PES_USER } from './currency-49e0d692.js';

const createQueries = (params) => {
  let queryString = '';
  for (const key in params) {
    if (params && params.hasOwnProperty(key)) {
      queryString += `&${key}=${params[key]}`;
    }
  }
  return queryString.slice(1);
};
const addParams = (url, params = {}) => {
  if (!isEmpty_1(params)) {
    return `${url}${url.includes('?') ? '&' : '?'}${createQueries(params)}`;
  }
  return url;
};
const request = (url, params = {}) => {
  return fetch(url, Object.assign(Object.assign({ method: 'GET', mode: 'cors' }, params), { headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    } })).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      return response.json();
    }
    throw response.status;
  });
};
const http = {
  post(url, params = {}, requestConfig) {
    const requestInit = Object.assign(Object.assign({}, requestConfig), { method: "POST" });
    if (!isEmpty_1(params)) {
      requestInit.body = JSON.stringify(params);
    }
    return request(url, requestInit);
  },
  delete(url, params = {}, requestConfig) {
    return request(addParams(url, params), Object.assign(Object.assign({}, requestConfig), { method: "DELETE" }));
  },
  get(url, params = {}, requestConfig) {
    return request(addParams(url, params), requestConfig);
  },
};
const makeGetData = () => (data, rest, authorization) => {
  if (data) {
    return new Promise((resolve) => resolve(data));
  }
  const header = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const userToken = sessionStorage.getItem(PES_USER.TOKEN_KEY);
  if (userToken)
    header['User-Authorization'] = userToken;
  if (authorization) {
    header.Autorization = authorization;
  }
  if (rest && isBrowser()) {
    return fetch(rest, {
      method: 'GET',
      mode: 'cors',
      headers: header,
    }).then((response) => {
      if (response.status === 200) {
        return response.json();
      }
      throw response.status;
    });
  }
  return new Promise((resolve) => resolve(null));
};
const getData = makeGetData();

export { getData as g, http as h };
